export const itemsData = [
  {
    icon: "clock outline",
    title: "Cursos y Clases",
    description:
      "Cursos de actualizados de diferentes temáticas con un formato dinámico y estructurado en clases cortas.",
  },
  {
    icon: "key",
    title: "Acceso 24/7",
    description:
      "Accede a los cursos en cualquier momento, desde cualquier lugar sin importar día y hora.",
  },
  {
    icon: "comment alternate outline",
    title: "Aprendizaje colaboratico",
    description:
      "Aprende de los demás dejando tus dudas para que profesores y compañeros te ayuden.",
  },
  {
    icon: "user circle outline",
    title: "Asistente personalizado",
    description:
      "Los cursos disponen de asistente con IA que ayuda a resolver tus dudas en tiempo real.",
  },
  {
    icon: "dollar",
    title: "Precios bajos",
    description:
      "Obtén el curso que necesitas al mejor precio y ten acceso a el por tiempo ilimitado.",
  },
  {
    icon: "certificate",
    title: "Certificador de finalización",
    description: "Al completar tu un curso recibirás una certificación en PDF.",
  },
];
